import { render, staticRenderFns } from "./historyOrder.vue?vue&type=template&id=694e10fa&scoped=true&"
import script from "./historyOrder.vue?vue&type=script&lang=js&"
export * from "./historyOrder.vue?vue&type=script&lang=js&"
import style0 from "./historyOrder.vue?vue&type=style&index=0&id=694e10fa&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "694e10fa",
  null
  
)

export default component.exports